import { useState } from "react"
import { isMobile } from "react-device-detect"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { CategoriesSortHomePage } from "../../constants"
import useMixpanelTrack from "../../hooks/useMixpanelTracking"
import { MenCategoryThumbnails, WomenCategoryThumbnails } from "../../utility/CategoryThumbnails"
import PillButton from "./PillButton"


const V2CategoriesHomePage = () => {

  const userLoggedIn = useSelector(state => state.userLoggedIn)
  const navidate = useNavigate()
  const trackEvent = useMixpanelTrack()
  const [clickedCategory, setClickedCategory] = useState(null);

  const setCategory = (cat, gender, type) => {
    //   if (location.pathname == '/women-social-trends' || location.pathname == '/men-social-trends') {
    //      setSearchParams(prev => {
    //        prev.set('category', cat);
    //        return prev;
    //      })
    trackEvent(`Homepage ${type.split('-').join(' ')} button click`, { category: cat, gender })
    const url = type == 'trends' ? `${gender == 'Female' ? '/women-social-trends' : 'men-social-trends'}?category=${cat.split('&').join('%26')}` :
      type == 'leaderboard' ? `v2-leaderboard?gender=${gender}&category=${encodeURIComponent(cat)}&time=${cat == 'Ethinic Wear' ? '60' : gender == 'Male' ? '30' : '15'}+days&geography=All&source=` :
        type == 'design-images' ? `design-recipe-images?gender=${gender == 'Female' ? 'F' : 'M'}&category=${encodeURIComponent(cat)}&time=${cat == 'Ethinic Wear' ? '180' : '30'}+days&geography=${cat == 'Ethinic Wear' ? 'All' : 'All'}${cat == 'Ethinic Wear' ? '&sort=recency' : ''}` :
          type == 'design-builder' ? `build-designs?gender=${gender}&category=${encodeURIComponent(cat)}` :
            type == 'news-feed' ? `/news-feed?gender=${gender == 'Female' ? 'F' : 'M'}&category=${encodeURIComponent(cat)}` :
              type == 'demandforecast' ? `v2-leaderboard?gender=${gender}&category=${encodeURIComponent(cat)}&time=${cat == 'Ethinic Wear' ? '60' : gender == 'Male' ? '30' : '15'}+days&geography=All&source=&demandforecast=true` :
                `design-trends-lifecycle?gender=${gender}&category=${encodeURIComponent(cat)}&time=7+days&geography=All&source=&trends=social`
    navidate(url)
  }

  return <div className="flex w-screen justify-between text-[8px] lg:text-sm">
    {['Women', 'Men'].map(gender => <div className={`w-1/2 ${gender == 'Women' ? "border-r-4 border-r-slate-400" : ""}`} >
      <h2 className="text-center my-4 text-lg font-semibold">{gender}'s Categories</h2>
      <div className="flex justify-between px-1 align-top lg:px-4 flex-wrap h-20 lg:h-auto">
        {gender == 'Women' ? <>
          <PillButton text={'Women Apparel Newsfeed'} link='/all-news-feed?gender=F&category=apparel' />
          <PillButton text={'Women Bag, Footwear, Accessories Newsfeed'} link='/all-news-feed?gender=F&category=non-apparel' />
          <PillButton text={'Women India Newsfeed'} link='/all-news-feed?gender=F&category=apparel&geography=indian' />
        </> : <>
          <PillButton text={'Men Apparel Newsfeed'} link='/all-news-feed?gender=M&category=apparel' />
          <PillButton text={'Men Bag, Footwear, Accessories Newsfeed'} link='/all-news-feed?gender=M&category=non-apparel' />
        </>}
      </div>
      <div className=" flex shrink-0 flex-wrap">
        {Object.keys(gender == 'Women' ? WomenCategoryThumbnails : MenCategoryThumbnails).sort((a, b) => (CategoriesSortHomePage.indexOf(a) - CategoriesSortHomePage.indexOf(b))).map(cat => <div key={`${clickedCategory}-${cat}-${gender}`} className='p-0.5 lg:p-2 w-1/2 lg:w-1/4 shrink-0 flex justify-center group/indexing' >
          <button
            className={`w-full lg:w-4/5 rounded-lg border hover:shadow-lg relative group ${`${gender}-${cat}` == clickedCategory ? 'bg-slate-200' : ''} `}
            onClick={() => {
              setClickedCategory(prev => {
                const newCat = `${gender}-${cat}`
                return prev == newCat ? "" : newCat
              });
            }}
          >
            <div className="flex justify-center w-full p-2">
              <img src={(gender == 'Women' ? WomenCategoryThumbnails : MenCategoryThumbnails)[cat]} alt={cat} className='w-4/5' />
            </div>
            <p className="text-[14px] text-center lg:text-lg font-medium group-hover:font-semibold">{cat}</p>
            {(clickedCategory == `${gender}-${cat}` || !isMobile) ? <div className={`absolute  ${!isMobile ? 'hidden group-hover:block' : ''} bottom-0 w-[150%] lg:w-full  text-[12px] lg:text-[14px] bg-slate-100/90 rounded-t-xl z-20 group-even/indexing:right-0 group-odd/indexing:left-0`}>
              <div className="w-full hidden text-red-600 font-extrabold justify-end">
                <button className=" pr-2 pt-2" onClick={() => {
                  setClickedCategory(null)
                }}>X</button>
              </div>
              <button onClick={(e) => { e.stopPropagation(); setCategory(cat, gender == 'Women' ? 'Female' : 'Male', 'news-feed') }} className="w-full py-1 hover:shadow font-semibold" hidden={["Other Outerwear", "Jumpsuits"].includes(cat)}>News Feed</button>
              <button onClick={(e) => { e.stopPropagation(); setCategory(cat, gender == 'Women' ? 'Female' : 'Male', 'leaderboard') }} className="w-full py-1 hover:shadow font-semibold">Trend Leaderboard</button>
              <button onClick={(e) => { e.stopPropagation(); setCategory(cat, gender == 'Women' ? 'Female' : 'Male', 'demandforecast') }} className="w-full py-1 hover:shadow font-semibold">Demand Forecast</button>
              <button onClick={(e) => { e.stopPropagation(); setCategory(cat, gender == 'Women' ? 'Female' : 'Male', 'design-images') }} className="w-full py-1 hover:shadow font-semibold">Product Leaderboard</button>
              {cat != 'Ethinic Wear' ? <button onClick={(e) => { e.stopPropagation(); setCategory(cat, gender == 'Women' ? 'Female' : 'Male', 'design-builder') }} className="w-full py-1 hover:shadow font-semibold">Design Builder</button> : null}
              <button onClick={(e) => { setCategory(cat, gender == 'Women' ? 'Female' : 'Male', 'lifecycles') }} className="w-full py-1 hover:shadow font-semibold" hidden>Lifecycle</button>
              {
                userLoggedIn && userLoggedIn.curator && <button onClick={() => { setCategory(cat, gender == 'Women' ? 'Female' : 'Male', 'trends') }} className="w-full py-1 hover:shadow font-semibold">Deep Dive</button>
              }
            </div> : null}
          </button>
        </div>)}
      </div>
    </div>)
    }
  </div>
}

export default V2CategoriesHomePage
